import '../initialization';

import Class from './c-widget-date';
import './c-widget-date@.vue';

export default Class;